const styles = (theme) => ({
  root: {
    minHeight: 34,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
      '& svg': {
        color: 'inherit',
      },
      '& span': {
        color: 'inherit',
      },
    },
    '&:focus': {
      outline: `auto ${theme.spacing.unit * 0.25}px ${
        theme.palette.primary.light
      }`,
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 40,
      minWidth: 40,
    },
  },
  small: {
    minHeight: 32,
    minWidth: 32,
  },
  container: {
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'right',
  },
  icon: {
    width: 32,
    height: 32,
    color: theme.palette.primary.dark,
  },
  label: {
    fontSize: '1.0625',
    fontWeight: 500,
    paddingRight: theme.spacing.unit / 2,
    color: theme.palette.text.dark,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
  },
  withBorder: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.primary.dark,
    borderRadius: '5px',
  },
  withPadding: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 1.5,
    '& svg': {
      width: 22,
      height: 22,
    },
  },
});

export default styles;
